import React from "react";
import { Link } from "react-router-dom";
import "../styles/NotFound.css";
import { useTranslation } from 'react-i18next';

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="notfound">
      <h1>404</h1>
      <h2>{t('notfound.subtitle')}</h2>
      <p>{t('notfound.message')}</p>
      <Link className="notfound-button" to="/">
        {t('notfound.button')}
      </Link>
    </div>
  );
}
